import { createAction } from "typesafe-actions";

import { createActionNamespace } from "app/pages/sales-intelligence/store/utils";

import type { AiThreadMessage, ThreadMessage, VersionThreadMessage } from "../../types/thread";

import type { UserMessageData } from "./types";

const actionNamespace = createActionNamespace("si/ai-agent/chat");

export const setChatText = createAction(actionNamespace("set-text"))<string>();

export const setMessages = createAction(actionNamespace("set-messages"))<readonly ThreadMessage[]>();

export const setIsInitialChatState = createAction(actionNamespace("set-is-initial-chat-state"))<boolean>();

export const addMessage = createAction(actionNamespace("add-message"))<ThreadMessage>();

export const addHumanMessage = createAction(actionNamespace("add-human-message"))<string>();

export const addAgentMessage = createAction(actionNamespace("add-agent-message"))<Omit<AiThreadMessage, "type">>();

export const addVersionMessage = createAction(actionNamespace("add-version-message"))<{
    message: Omit<VersionThreadMessage, "type">;
    disabledVersions?: string[];
}>();

export const setUserMessageData = createAction(actionNamespace("set-user-message-data"))<UserMessageData>();

export const setMessageError = createAction(actionNamespace("set-message-error"))<{
    messageId: string;
    error: string;
}>();

export const clearMessages = createAction(actionNamespace("clear-messages"))<void>();

export const clearAiAgentChatState = createAction(actionNamespace("clear-chat-state"))<void>();

export const clearChatText = createAction(actionNamespace("clear-text"))();
